<script setup>
import SmartDisplayC from '@rebuild/components/SmartDisplayC.vue';
import { usePureModule } from '@rebuild/hooks/usePureModule';

const { isMobile, activeModule, getModuleId, getModuleProps } = usePureModule();
</script>

<template>
	<!-- 新 /pure 访问模式 -->
	<div class="pure-component-frame">
		<SmartDisplayC
			:compId="getModuleId(activeModule)"
			:mode="isMobile ? 'mob-pure' : 'pure'"
			v-bind="getModuleProps(activeModule)"
		/>
	</div>
</template>

<style lang="less" scoped></style>
